import React from "react";
import Header from "@/utilities/Quiz/QuizHeader/quizHeader";
import Quiz1 from "@/utilities/Quiz/QuizHeader/Quiz1";

function quiz() {
  return (
    <div>
      <Header />
      <Quiz1 />
    </div>
  );
}
quiz.hideLayout = true;
export default quiz;
